
import Button from "../components/button";
import FormHead from "../components/headings/FromHead";
import Styles from "./styles.module.scss";
import { FormInput } from "../wrappers/formInput";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Datepicker from "../components/datepicker";
import * as Utils from '../utils/EllowUtils';
import { useEffect, useMemo, useState } from "react";
import { Error } from "@progress/kendo-react-labels";




export type EducationFormFields = {
  degree: string;
  institution: string;
  startDate: number;
  endDate: number;
  action: string; 
};

interface Props {
  ClickHandler :any;
  onClose:any;
  defaultValues: any
}
const validationSchema = Yup.object({
    degree:Yup.string()
    .required('Field is required'),
    institution:Yup.string()
    .required('Field is required'),
 } )

  const Education: React.FC<Props> = ({
    ClickHandler,
    onClose,
    defaultValues
  }) => { 
    
    const formOptions = {
      resolver:yupResolver(validationSchema), defaultValues: useMemo(() => {
        return defaultValues;
      }, [defaultValues])
    }

    const [error, setError] = useState<{startDate?: string, endDate?: string}>({ startDate: '', endDate: ''})
    const [disable, setDisable] = useState(false);
    const [startDateState, setStartDateState] = useState<any>()

    let startdate = defaultValues && defaultValues.startDate ? new Date(defaultValues.startDate) : 0
    let enddate = defaultValues && defaultValues.endDate ? new Date(defaultValues.endDate) : 0   


    const {
      register,
      handleSubmit,
      reset,
      setValue,
      formState: { errors },
    } = useForm<EducationFormFields>(formOptions);
  
    useEffect(() => {
      if (defaultValues) {
        if (defaultValues?.startDate) {
          setStartDateState(new Date(defaultValues.startDate))
        }
        reset(defaultValues);
        setValue('action', 'update')
      }else {
        setValue('action', 'add')
      } 
    }, [defaultValues, defaultValues.education, reset, setValue]);

    const onSubmit = (data:any) => {

      let hasError: boolean = false

      if ( data.startDate){
        data.startDate = Utils.getMilliSecUTC(data.startDate)
      }else{
        error.startDate = 'Field is required'
        hasError = true
      }
      if ( data.endDate){
        data.endDate = Utils.getMilliSecUTC(data.endDate)
      }else if (!data.stillWorking){
        error.endDate = 'Field is required'   
        hasError = true
      }
      // data.startDate = Utils.getMilliSec(data.startDate)
      // data.endDate = Utils.getMilliSec(data.endDate)
      if ( !hasError ) {  
        setDisable(true)
        ClickHandler(data)
      }

    }
   
    const handleDateChange = (e:any,name:any) => { 
        setValue(name,e.target.value)    
        if (name === 'startDate'){
          delete error?.startDate   
          setError({...error})
          setStartDateState(new Date(e.target.value))
        }
        if (name === 'endDate'){
          delete error?.endDate   
          setError({...error})
        }  
    }

    return(
      <div className={Styles.detailsCard}>
          <FormHead>Education</FormHead>
            <div className="form-group">
                <FormInput<EducationFormFields>
                  id="degree"
                  type="text"
                  name="degree"
                  label="Degree*"
                  placeholder=""
                  register={register}
                  errors={errors}
                />
            </div>
              <div className="form-group">
                  <FormInput<EducationFormFields>
                    id="institution"
                    type="text"
                    name="institution"
                    label="College*"
                    placeholder=""
                    register={register}
                    errors={errors}
                  />
              </div>
            <div className="half-form-wrap mb-0">
            <div className="form-group">
                  <label className="lablel">Start Date*</label>
                  <Datepicker
                  defaultShow={false}
                  defaultValue={startdate}
                  onChange={(e: any) => handleDateChange(e, 'startDate')}
                  />
                  <Error>{error?.startDate}</Error>
              </div>
            <div className="form-group">
                <label className="lablel">End Date*</label>
                  <Datepicker
                  defaultShow={false}
                  defaultValue={enddate}
                  onChange={(e: any) => handleDateChange(e, 'endDate')}
                  min={startDateState}
                  disabled={startDateState ? false : true}
                  />
                  <Error>{error?.endDate}</Error>
            </div>
            </div>
            <div className={Styles.popupAction}>
              <Button onClick={onClose} type="submit" variant="secondary" size="small">Cancel</Button>
              <Button disabled={disable} onClick={handleSubmit(onSubmit)} type="submit" variant="primary" size="small">Save</Button>
            </div>
        </div>
    )
}

export default Education;